// utils/pageTitle.js
//
// The browser tab's text: "House party tonight | invits - Create beautiful
// invitations" on an invitation or card, rather than the site's generic title
// on every page. It is what shows in the tab, in history and in bookmarks,
// and it is how someone with ten tabs open finds the party.
//
// functions/_preview.js writes the same format into the HTML the server sends,
// so the right title is there before this script runs; this keeps it right
// when the page is reached by navigating inside the site.

import { useEffect } from 'react';

export const SITE_TITLE_SUFFIX = 'invits - Create beautiful invitations';

/** "<name> | invits - Create beautiful invitations", or the suffix alone. */
export function pageTitle(name) {
  const clean = typeof name === 'string' ? name.trim() : '';
  return clean ? `${clean} | ${SITE_TITLE_SUFFIX}` : SITE_TITLE_SUFFIX;
}

/**
 * Sets the tab title while the calling page is shown, and puts the previous
 * one back when it goes. Does nothing until `name` is known, so a loading
 * page keeps whatever title it arrived with.
 */
export function usePageTitle(name) {
  useEffect(() => {
    if (!name) return undefined;
    const previous = document.title;
    document.title = pageTitle(name);
    return () => { document.title = previous; };
  }, [name]);
}
